export const getListItem = ({ position, pageTitle, uri }) => ({
  '@type': 'ListItem',
  position,
  name: pageTitle,
  item: `${process.env.SITE_URL}${uri}`,
});

export const getStructuredDataBreadcrumb = (breadcrumbsItems) => [
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbsItems,
  },
];

export const getStructuredDataBlogPosting = ({
  articleBody,
  authorName,
  dateModified,
  datePublished,
  description,
  headline,
  image,
  url,
}) => ({
  '@context': 'https://schema.org',
  '@type': 'BlogPosting',
  headline: headline,
  image: image,
  datePublished: datePublished,
  dateModified: dateModified,
  author: {
    '@type': 'Person',
    name: authorName,
  },
  url: url,
  publisher: {
    '@type': 'Organization',
    name: 'Sunhero',
    logo: 'https://www.sunhero.com/static/sunheroLogo-bf7b6a30e585199b1d2182f661d168c0.svg',
  },
  description: description,
  articleBody: articleBody,
});

export const getStructuredDataOrganization = ({ description }) => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  url: 'https://www.sunhero.com/',
  sameAs: [
    'https://www.facebook.com/sunherosolar',
    'https://www.instagram.com/sunherosolar/',
    'https://www.linkedin.com/company/sunhero',
  ],
  logo: 'https://www.sunhero.com/static/sunheroLogo-bf7b6a30e585199b1d2182f661d168c0.svg',
  name: 'Sunhero',
  description: description,
  email: 'contact@sunhero.com',
  telephone: '+34-623-560-332',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Calle Pere IV 128',
    addressLocality: 'Barcelona',
    addressCountry: 'ES',
    postalCode: '08005',
  },
});

export const getStructuredDataYouTubeEmbed = ({
  videoId,
  title,
  description,
  publishTime,
  duration,
}) => ({
  '@context': 'https://schema.org/',
  '@type': 'VideoObject',
  name: title,
  description,
  uploadDate: publishTime,
  duration,
  url: `https://www.youtube.com/watch?v=${videoId}`,
  contentUrl: `https://www.youtube.com/v/${videoId}`,
  embedUrl: `https://www.youtube.com/embed/${videoId}`,
  thumbnailUrl: `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`,
});

export const getBreadcrumbsItems = ({ breadcrumbs, homePageLabel, homeUri }) =>
  breadcrumbs.map(({ text, url }, index) => {
    if (index === 0) {
      return getListItem({
        position: 1,
        pageTitle: homePageLabel,
        uri: homeUri,
      });
    }
    const position = index + 1;
    return getListItem({ position, pageTitle: text, uri: url });
  });

export const getVideoIDs = (html) => [
  // set it as unique values using the Set
  ...new Set(
    [
      // get the iterator that matches the youtube embed signature, and define a capture group "videoId"
      ...html.matchAll(
        /https:\/\/www\.youtube(-nocookie)?\.com\/embed\/(?<videoId>.*)\?/gm,
      ),
    ].map((match) => match.groups.videoId),
  ),
];

export const getVideosStructuredData = ({ videos, videoIds }) =>
  videos
    .filter((video) => videoIds.includes(video.videoId))
    .map((video) => getStructuredDataYouTubeEmbed({ ...video }));
